import { Injectable } from '@angular/core';
import { Theme, light, dark } from './theme';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private active: Theme = dark;
  private availableThemes: Theme[] = [light, dark];

  getAvailableThemes(): Theme[] {
    return this.availableThemes;
  }

  getActiveTheme(): Theme {
    return this.active;
  }

  isDarkTheme(): boolean {
    return this.active.name === dark.name;
  }

  setDarkTheme(): void {
    this.setActiveTheme(dark);
  }

  setLightTheme(): void {
    this.setActiveTheme(light);
  }

  setActiveTheme(theme: Theme): void {
    this.active = theme;

    Object.keys(this.active.properties).forEach((property) => {
      document.documentElement.style.setProperty(
        property,
        this.active.properties[property]
      );
    });
  }

  setSvgColor(lightTheme: string, darkTheme: string) {
    let activeTheme = this.getActiveTheme();
    let outputColor: string;

    if (activeTheme.name == 'light') {
      outputColor = lightTheme;
    } else {
      outputColor = darkTheme;
    }

    return outputColor;
  }
}
